export default function SectionHeader({
  badge,
  title,
  description,
  sideTitle,
  sideSubtitle,
  showLine = false,
  action,
  headingTag: Heading = "h1",
  secondAction
}) {
  return (
    <div className="mb-12">

      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">

        <div className="flex-1 max-w-4xl">
          {badge && (
            <p className="text-xs md:text-sm font-semibold text-blue-700 uppercase tracking-[0.2em] mb-3 font-serif">
              {badge}
            </p>
          )}

          <Heading
            className="
              text-3xl
              md:text-4xl
              lg:text-5xl
              font-black
              tracking-tight
              text-slate-900
              leading-none
              font-serif
            "
          >
            {title}
          </Heading>

          {showLine && (
            <div className="w-16 h-1 bg-blue-700 rounded-full mt-5" />
          )}
        </div>


        {(sideTitle || sideSubtitle || action) && (
          <div className="lg:text-right shrink-0">
            {sideTitle && (
              <p className="text-[11px] uppercase tracking-[0.3em] text-slate-400 font-bold">
                {sideTitle}
              </p>
            )}

            {sideSubtitle && (
              <p className="text-sm font-semibold text-slate-700 mt-1">
                {sideSubtitle}
              </p>
            )}

            {action && <div className="mt-4">{action}</div>}
                        {secondAction && <div className="mt-4">{secondAction}</div>}
          </div>
        )}
      </div>


      {description && (
        <div className="max-w-3xl mt-6">
          <p className="text-slate-600 leading-relaxed text-sm md:text-base font-serif">
            {description}
          </p>
        </div>
      )}
    </div>
  );
}